import styled from 'styled-components';

export const RestWebServicesWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.text-align-center{
    text-align: center;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
p, li, th, td {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #334155;
}
.reduced-img{
    width: 50%;
}
/* Media query for mobile devices (screen width 768px and below) */
	@media screen and (max-width: 768px) {
	  .reduced-img{
		width: 100%
	  }
	}
`;
